<template>
    <b-container class="hero-container">
        <b-row class="hero">
            <b-col cols="12" lg="8">
                <b-card
                    tag="article"
                    class="heroCard mb-2">
                    <b-card-text class="fredericka display-2">Accelerate<br/>Math Achievement<br/>for Every Student</b-card-text>
                    <b-card-text class="">Empowering educators to easily track and accelerate student progress towards grade level Common Core Math standards.</b-card-text>
                    <div>
                        <Link href="/free-trial" class="btn btn-success mr-2">Schedule my free pilot!</Link>
                        <Link href="/#tagline" class="btn btn-outline-light">Learn more</Link>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" lg="3" class="heroImg">
                <!-- <div class="kevin-standing"></div>-->
                <kevin></kevin>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Kevin from './Dog/Kevin.vue';
    export default {
        components: {
            Kevin,
        }
    }
</script>

<style lang="scss" scoped>
    .hero-container {
        max-width: 1440px !important;
    }

    .hero {
        position: relative;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        top: 8rem;

        .heroCard {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 1rem;
            font-size: 32px;
            height: fit-content;
            color: #fff;
            background: #333;
            border: 10px solid #C27C4A;

            .fredericka {
                font-family: 'Fredericka the Great', cursive;
            }

            .card-text {
                font-size: 30px;
            }
            
            .display-2 {
                font-size: 75px;
                font-weight: 500;
            }

            .btn {
                font-weight: 600;

                &.btn-success {
                    color: #333;
                    background-color: #BBDF00;
                    border-color: #BBDF00;
                }
            }
        }

        .hero-btn-float {
            padding: 30px 0 60px;
            width: 100%;
        }

        .hero-btn-wrapper {
            position: absolute;
            left: -100px;
            width: 100vw;
            height: 100vh;
        }
    }

    .card {
        border: none;
    }

    @media (max-width: 1200px) {
        p.display-2 {
            font-size: 68px !important;
        }
    }
    @media (max-width: 992px) {	
        .hero {
            top: 6rem;
            .hero-card {
                width: 100%;
                p.display-2 {
                    font-size: 50px !important;
                }
                .card-text {
                    font-size: 31px;
                }
            }
            .heroImg {
                display: none;
            }
        }
    }
    @media (max-width: 768px) {
        .hero-container {
            max-width: 90% !important;
        }

        .hero {
            flex-wrap: wrap;
            .heroCard {
                padding: 0;
                p.display-2 {
                    font-size: 58px !important;
                }
                .card-text {
                    font-size: 24px !important;
                }
            }
        }
    }
    @media (max-width: 576px) {
        .hero-container {
            max-width: 100% !important;
        }
        .hero {
            .heroCard {
                p.display-2 {
                    font-size: 48px !important;
                }
                .card-text {
                    font-size: 22px;
                }
            }
        }
    }
    @media (max-width: 425px) {
        .hero {
            .heroCard {
                p.display-2 {
                    font-size: 42px !important;
                }
                .card-text {
                    font-size: 22px;
                }
            }
        }
    }
    @media (max-width: 380px) {
        .hero {
            .heroCard {
                p.display-2 {
                    font-size: 30px !important;
                }
            }
        }
    }

</style>
